<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        Report Income Statement (Profil/(Loss)) per Dimension
        <div class="card-header-actions">
          <button class="btn btn-primary mr-1" @click="process()">
            <i class="fa fa-play"></i>
            Process
          </button>
          <button class="btn btn-primary mr-1" @click="print()">
            <i class="fa fa-print"></i>
            print
          </button>
          <button class="btn btn-primary mr-1" @click="exportxls()">
            <i class="fa fa-file-excel-o"></i>
            Export
          </button>
          <button class="btn btn-danger mr-1" @click="close()">
            <i class="fa fa-close"></i> Close
          </button>
        </div>
      </div>
      <b-row>
        <b-col lg="3">
          <b-input-group>
            <b-input-group-prepend
              ><span class="pt-2 mr-2">Line Layout</span></b-input-group-prepend
            >
            <b-form-select
              v-model="filter.layout"
              :plain="true"
              :options="layouts"
              :state="!$v.filter.layout.$error"
            ></b-form-select>
          </b-input-group>
        </b-col>
        <b-col lg="5">
          <b-input-group>
            <b-input-group-prepend
              ><span class="pt-2 mr-2">Dimension</span></b-input-group-prepend
            >
            <b-form-select
              v-model="filter.DimCol"
              :plain="true"
              :options="dimension"
              :state="!$v.filter.DimVal.$error"
            ></b-form-select>
            <b-form-input
              readonly
              v-model="filter.DimValInfo"
              placeholder="Dimension Value"
              :state="!$v.filter.DimVal.$error"
              class="ml-1"
            ></b-form-input>
            <b-input-group-append>
              <b-btn text="Button" @click="lkuDimShow = true">
                <i class="fa fa-search"></i>
              </b-btn>
            </b-input-group-append>
          </b-input-group>
        </b-col>
        <b-col lg="4">
          <b-input-group>
            <b-input-group-prepend
              ><span class="pt-2 mr-2"
                >Periode Date</span
              ></b-input-group-prepend
            >
            <b-form-input
              v-model="filter.tgl1"
              type="date"
              placeholder="from date"
              readonly
              class="mr-1"
            ></b-form-input>
            <b-form-input
              v-model="filter.tgl2"
              type="date"
              placeholder="until date"
              @change="updateTgl1"
              :state="!$v.filter.tgl2.$error"
            ></b-form-input>
          </b-input-group>
        </b-col>
      </b-row>
      <b-card no-body>
        <b-tabs card v-model="filter.tabIndex">
          <b-tab title="Summary 12 Months" active>
            <div class="report-wraper">
              <table>
                <thead>
                  <tr>
                    <th width="400px">Description</th>
                    <th
                      v-if="filter.tgl2"
                      style="text-align: right"
                      width="110px"
                    >
                      Jan {{ filter.tgl2 | moment("YYYY") }}
                    </th>
                    <th
                      v-if="!filter.tgl2"
                      style="text-align: right"
                      width="110px"
                    >
                      Jan
                    </th>
                    <th
                      v-if="filter.tgl2"
                      style="text-align: right"
                      width="110px"
                    >
                      Feb {{ filter.tgl2 | moment("YYYY") }}
                    </th>
                    <th
                      v-if="!filter.tgl2"
                      style="text-align: right"
                      width="110px"
                    >
                      Feb
                    </th>
                    <th
                      v-if="filter.tgl2"
                      style="text-align: right"
                      width="110px"
                    >
                      Mar {{ filter.tgl2 | moment("YYYY") }}
                    </th>
                    <th
                      v-if="!filter.tgl2"
                      style="text-align: right"
                      width="110px"
                    >
                      Mar
                    </th>
                    <th
                      v-if="filter.tgl2"
                      style="text-align: right"
                      width="110px"
                    >
                      Apr {{ filter.tgl2 | moment("YYYY") }}
                    </th>
                    <th
                      v-if="!filter.tgl2"
                      style="text-align: right"
                      width="110px"
                    >
                      Apr
                    </th>
                    <th
                      v-if="filter.tgl2"
                      style="text-align: right"
                      width="110px"
                    >
                      May {{ filter.tgl2 | moment("YYYY") }}
                    </th>
                    <th
                      v-if="!filter.tgl2"
                      style="text-align: right"
                      width="110px"
                    >
                      May
                    </th>
                    <th
                      v-if="filter.tgl2"
                      style="text-align: right"
                      width="110px"
                    >
                      Jun {{ filter.tgl2 | moment("YYYY") }}
                    </th>
                    <th
                      v-if="!filter.tgl2"
                      style="text-align: right"
                      width="110px"
                    >
                      Jun
                    </th>
                    <th
                      v-if="filter.tgl2"
                      style="text-align: right"
                      width="110px"
                    >
                      Jul {{ filter.tgl2 | moment("YYYY") }}
                    </th>
                    <th
                      v-if="!filter.tgl2"
                      style="text-align: right"
                      width="110px"
                    >
                      Jul
                    </th>
                    <th
                      v-if="filter.tgl2"
                      style="text-align: right"
                      width="110px"
                    >
                      Aug {{ filter.tgl2 | moment("YYYY") }}
                    </th>
                    <th
                      v-if="!filter.tgl2"
                      style="text-align: right"
                      width="110px"
                    >
                      Aug
                    </th>
                    <th
                      v-if="filter.tgl2"
                      style="text-align: right"
                      width="110px"
                    >
                      Sep {{ filter.tgl2 | moment("YYYY") }}
                    </th>
                    <th
                      v-if="!filter.tgl2"
                      style="text-align: right"
                      width="110px"
                    >
                      Sep
                    </th>
                    <th
                      v-if="filter.tgl2"
                      style="text-align: right"
                      width="110px"
                    >
                      Oct {{ filter.tgl2 | moment("YYYY") }}
                    </th>
                    <th
                      v-if="!filter.tgl2"
                      style="text-align: right"
                      width="110px"
                    >
                      Oct
                    </th>
                    <th
                      v-if="filter.tgl2"
                      style="text-align: right"
                      width="110px"
                    >
                      Nov {{ filter.tgl2 | moment("YYYY") }}
                    </th>
                    <th
                      v-if="!filter.tgl2"
                      style="text-align: right"
                      width="110px"
                    >
                      Nov
                    </th>
                    <th
                      v-if="filter.tgl2"
                      style="text-align: right"
                      width="110px"
                    >
                      Dec {{ filter.tgl2 | moment("YYYY") }}
                    </th>
                    <th
                      v-if="!filter.tgl2"
                      style="text-align: right"
                      width="110px"
                    >
                      Dec
                    </th>
                    <th style="text-align: right" width="110px">Total</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="row in rptLines" :key="row.idrowunik">
                    <td :class="row.kelas">
                      <span v-html="row.uraianhtm"></span>
                    </td>
                    <td
                      :class="row.kelas"
                      v-if="row.kode || row.rumus"
                      @click="drillMonthly(row, 1)"
                      style="text-align: right"
                    >
                      {{ row.jan | numFormat("0,0.00") }}
                    </td>
                    <td v-else></td>
                    <td
                      :class="row.kelas"
                      v-if="row.kode || row.rumus"
                      @click="drillMonthly(row, 2)"
                      style="text-align: right"
                    >
                      {{ row.feb | numFormat("0,0.00") }}
                    </td>
                    <td v-else></td>
                    <td
                      :class="row.kelas"
                      v-if="row.kode || row.rumus"
                      @click="drillMonthly(row, 3)"
                      style="text-align: right"
                    >
                      {{ row.mar | numFormat("0,0.00") }}
                    </td>
                    <td v-else></td>
                    <td
                      :class="row.kelas"
                      v-if="row.kode || row.rumus"
                      @click="drillMonthly(row, 4)"
                      style="text-align: right"
                    >
                      {{ row.apr | numFormat("0,0.00") }}
                    </td>
                    <td v-else></td>
                    <td
                      :class="row.kelas"
                      v-if="row.kode || row.rumus"
                      @click="drillMonthly(row, 5)"
                      style="text-align: right"
                    >
                      {{ row.mei | numFormat("0,0.00") }}
                    </td>
                    <td v-else></td>
                    <td
                      :class="row.kelas"
                      v-if="row.kode || row.rumus"
                      @click="drillMonthly(row, 6)"
                      style="text-align: right"
                    >
                      {{ row.jun | numFormat("0,0.00") }}
                    </td>
                    <td v-else></td>
                    <td
                      :class="row.kelas"
                      v-if="row.kode || row.rumus"
                      @click="drillMonthly(row, 7)"
                      style="text-align: right"
                    >
                      {{ row.jul | numFormat("0,0.00") }}
                    </td>
                    <td v-else></td>
                    <td
                      :class="row.kelas"
                      v-if="row.kode || row.rumus"
                      @click="drillMonthly(row, 8)"
                      style="text-align: right"
                    >
                      {{ row.agt | numFormat("0,0.00") }}
                    </td>
                    <td v-else></td>
                    <td
                      :class="row.kelas"
                      v-if="row.kode || row.rumus"
                      @click="drillMonthly(row, 9)"
                      style="text-align: right"
                    >
                      {{ row.sep | numFormat("0,0.00") }}
                    </td>
                    <td v-else></td>
                    <td
                      :class="row.kelas"
                      v-if="row.kode || row.rumus"
                      @click="drillMonthly(row, 10)"
                      style="text-align: right"
                    >
                      {{ row.okt | numFormat("0,0.00") }}
                    </td>
                    <td v-else></td>
                    <td
                      :class="row.kelas"
                      v-if="row.kode || row.rumus"
                      @click="drillMonthly(row, 11)"
                      style="text-align: right"
                    >
                      {{ row.nov | numFormat("0,0.00") }}
                    </td>
                    <td v-else></td>
                    <td
                      :class="row.kelas"
                      v-if="row.kode || row.rumus"
                      @click="drillMonthly(row, 12)"
                      style="text-align: right"
                    >
                      {{ row.des | numFormat("0,0.00") }}
                    </td>
                    <td v-else></td>
                    <td
                      :class="row.kelas"
                      v-if="row.kode || row.rumus"
                      @click="drillMonToDate(row)"
                      style="text-align: right"
                    >
                      {{ row.total | numFormat("0,0.00") }}
                    </td>
                    <td v-else></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </b-tab>
          <b-tab title="Current Month & Month To Date" active>
            <div class="report-wraper">
              <table style="width: 100%">
                <thead>
                  <tr>
                    <th width="110px">Src.Code</th>
                    <th>Description</th>
                    <th
                      v-if="filter.tgl2"
                      style="text-align: right"
                      width="110px"
                    >
                      {{ filter.tgl2 | moment("MMM-YYYY") }}
                    </th>
                    <th v-else style="text-align: right" width="150px">
                      Current Month
                    </th>
                    <th style="text-align: right" width="110px">%</th>
                    <th
                      v-if="filter.tgl2"
                      style="text-align: right"
                      width="180px"
                    >
                      As of {{ filter.tgl2 | moment("MMM-YYYY") }}
                    </th>
                    <th v-else style="text-align: right" width="180px">
                      Month to Date
                    </th>
                    <th style="text-align: right" width="110px">%</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="row in rptLines" :key="row.idrowunik">
                    <td :class="row.kelas">{{ row.kode }}</td>
                    <td :class="row.kelas">
                      <span v-html="row.uraianhtm"></span>
                    </td>
                    <td
                      :class="row.kelas"
                      v-if="row.kode || row.rumus"
                      @click="drillCurrentMonth(row)"
                      style="text-align: right"
                    >
                      {{ row.monthtt | numFormat("0,0.00") }}
                    </td>
                    <td v-else></td>
                    <td
                      :class="row.kelas"
                      v-if="row.kode || row.rumus"
                      style="text-align: right"
                    >
                      {{ row.persen_month | numFormat("0,0.00") }}
                    </td>
                    <td v-else></td>
                    <td
                      :class="row.kelas"
                      v-if="row.kode || row.rumus"
                      @click="drillMonToDate(row)"
                      style="text-align: right"
                    >
                      {{ row.total | numFormat("0,0.00") }}
                    </td>
                    <td v-else></td>
                    <td
                      :class="row.kelas"
                      v-if="row.kode || row.rumus"
                      style="text-align: right"
                    >
                      {{ row.persen_md | numFormat("0,0.00") }}
                    </td>
                    <td v-else></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </b-tab>
        </b-tabs>
      </b-card>
    </b-card>
    <loading
      :active.sync="isLoading"
      :height="128"
      :width="128"
      color="#4b8cf4"
    ></loading>
    <b-modal
      v-model="showReport"
      size="xl"
      scrollable
      title="Preview as PDF"
      ok-only
    >
      <iframe v-if="reportUrl" :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
    <b-modal
      v-model="lkuDimShow"
      size="lg"
      :hide-footer="true"
      title="List of Dimension Value"
      :centered="true"
    >
      <lku-dim
        @click="onSelectedDim"
        :DimColName="filter.DimCol"
        :key="filter.DimCol"
      ></lku-dim>
    </b-modal>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import lkuDim from "../lookup/lkuDim";
import incomestat from "../../apis/incomestat";
import toastr from "mini-toastr";
import moment from "moment";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
    filter: {
      layout: { required },
      DimCol: { required },
      DimVal: { required },
      tgl1: { required },
      tgl2: { required },
    },
  },
  data() {
    return {
      filter: {
        tabIndex: 1,
        DimCol: "",
        DimVal: "",
        layout: "",
        tgl1: "",
        tgl2: "",
      },
      isLoading: false,
      layouts: [],
      lkuDimShow: false,
      reportUrl: null,
      showReport: false,
      rptLines: [],
    };
  },
  components: { Loading, lkuDim },
  computed: {
    dimension() {
      return this.$store.state.dimension;
    },
    dimCol() {
      return this.filter.DimCol;
    },
    invalidFilter() {
      this.$v.filter.$touch();
      return this.$v.filter.$invalid;
    },
    layout() {
      return this.filter.layout;
    },
  },
  watch: {
    dimCol: function (newval) {
      this.filter.DimVal = "";
      this.filter.DimValInfo = "";
      this.filter.DimColInfo = this.dimension.find(
        (d) => d.value === newval
      ).text;
    },
    layout: async function (newval) {
      //   this.rptLines= await incomestat.layout({layout : newval});
      const lines = await incomestat.layout({ layout: newval });
      const hasil = lines.reduce((newArr, line) => {
        if (line.item_hapus !== 1) newArr.push(line);
        return newArr;
      }, []);
      this.rptLines = hasil;
    },
  },
  created: async function () {
    this.layouts = await incomestat.layout_combo();
    var tgl2 = moment(this.$store.state.user.tglaktif, "YYYY-MM-DD")
      .add(1, "M")
      .subtract(1, "day");
    var tgl1 = moment(tgl2.format("YYYY") + "-01-01", "YYYY-MM-DD");
    this.filter.tgl1 = tgl1.format("YYYY-MM-DD");
    this.filter.tgl2 = tgl2.format("YYYY-MM-DD");
    this.filter.DimCol = this.dimension[0].value;
  },
  methods: {
    updateTgl1: function () {
      var tgl2 = moment(this.filter.tgl2, "YYYY-MM-DD");
      var tgl1 = moment(tgl2.format("YYYY") + "-01-01", "YYYY-MM-DD");
      this.filter.tgl1 = tgl1.format("YYYY-MM-DD");
    },
    process: async function () {
      if (this.invalidFilter) {
        toastr.error("Please fill the form correctly.");
      } else {
        this.isLoading = true;
        try {
          const model = {};
          for (var key in this.filter) {
            model[key] = this.filter[key];
          }
          model.tgl1 = moment(this.filter.tgl1).format("YYYY-MM-DD");
          model.tgl2 = moment(this.filter.tgl2).format("YYYY-MM-DD");
          this.rptLines = await incomestat.pnldim1(model);
          this.isLoading = false;
        } catch (error) {
          this.isLoading = false;
          if (error.message) {
            toastr.error(error.message);
          } else {
            toastr.error(JSON.stringify(error));
          }
        }
      }
    },
    print: async function () {
      if (this.invalidFilter) {
        toastr.error("Please fill the form correctly.");
      } else {
        try {
          this.reportUrl = null; this.showReport = true;
          const model = {};
          for (var key in this.filter) {
            model[key] = this.filter[key];
          }
          model.tgl1 = moment(this.filter.tgl1).format("YYYY-MM-DD");
          model.tgl2 = moment(this.filter.tgl2).format("YYYY-MM-DD");
          this.reportUrl = await incomestat.pnldim1print(model);
        } catch (error) {
          if (error.message) {
            toastr.error(error.message);
          } else {
            toastr.error(JSON.stringify(error));
          }
        }
      }
    },
    exportxls: async function () {
      if (this.invalidFilter) {
        toastr.error("Please fill the form correctly.");
      } else {
        this.isLoading = true;
        try {
          const model = {};
          for (var key in this.filter) {
            model[key] = this.filter[key];
          }
          model.tgl1 = moment(this.filter.tgl1).format("YYYY-MM-DD");
          model.tgl2 = moment(this.filter.tgl2).format("YYYY-MM-DD");
          const response = await incomestat.pnldim1export(model);
          this.isLoading = false;
        } catch (error) {
          this.isLoading = false;
          if (error.message) {
            toastr.error(error.message);
          } else {
            toastr.error(JSON.stringify(error));
          }
        }
      }
    },
    drillMonthly: function (data, monthOf) {
      if (data.kode) {
        var tgl1 = moment(`${this.tahun}-${monthOf}-01`, "YYYY-MM-DD");
        // let routeData = router.resolve({path: `dim-detailtrx/${this.filter.DimCol}/${this.filter.DimVal}/${data.kode}/${tgl1.format('YYYY-MM-DD')}/${tgl1.add(1,'M').subtract(1, 'day').format('YYYY-MM-DD')}`});
        let routeData = router.resolve({
          name: "accounting.glpnldim",
          params: {
            DimCol: this.filter.DimCol,
            DimVal: this.filter.DimVal,
            DimValInfo: this.filter.DimValInfo,
            kodeaw: data.kode,
            tgl1: this.filter.tgl1,
            tgl2: tgl1.add(1, "M").subtract(1, "day"),
          },
        });
        window.open(routeData.href, "_blank");
      }
    },
    drillCurrentMonth: function (row) {
      if (data.kode) {
        var tgl2 = moment(this.filter.tgl2, "YYYY-MM-DD");
        // let routeData = router.resolve({path: `dim-detailtrx/${this.filter.DimCol}/${this.filter.DimVal}/${data.kode}/${tgl2.format('YYYY-MM')}-01/${this.filter.tgl2}`});
        let routeData = router.resolve({
          name: "accounting.glpnldim",
          params: {
            DimCol: this.filter.DimCol,
            DimVal: this.filter.DimVal,
            DimValInfo: this.filter.DimValInfo,
            kodeaw: data.kode,
            tgl1: tgl2.startOf("month"),
            tgl2: this.filter.tgl2,
          },
        });
        window.open(routeData.href, "_blank");
      }
    },
    drillMonToDate: function (data) {
      if (data.kode) {
        // let routeData = router.resolve({path: `dim-detailtrx/${this.filter.DimCol}/${this.filter.DimVal}/${data.kode}/${this.filter.tgl1}/${this.filter.tgl2}`});
        let routeData = router.resolve({
          name: "accounting.glpnldim",
          params: {
            DimCol: this.filter.DimCol,
            DimVal: this.filter.DimVal,
            DimValInfo: this.filter.DimValInfo,
            kodeaw: data.kode,
            tgl1: this.filter.tgl1,
            tgl2: this.filter.tgl2,
          },
        });
        window.open(routeData.href, "_blank");
      }
    },
    onSelectedDim: function (_selected) {
      this.filter.DimVal = _selected.kode;
      this.filter.DimValInfo = `${_selected.kode.trim()} | ${_selected.nama}`;
      this.$forceUpdate();
      this.lkuDimShow = false;
    },
    close() {
      router.push("home");
    },
  },
};
</script>
